export type ResetPasswordErrorCode = 'NOT_FOUND' | 'UNKNOWN';

export class ResetPasswordError extends Error {
    code: ResetPasswordErrorCode;

    constructor(code: ResetPasswordErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
